import React from 'react'
import { Box } from '@mui/material'

import { dsColorNew } from '@palette'
import { cellBg } from 'Pages/BusinessLogistics/Dashboards/OfficeNetwork/Page/@components/DistanceCell'
import { unitLine } from '../@services/windowLabel'


const swatch = (side, level) => <Box component="span" key={`${side}${level}`} sx={{ width: 18, height: 12, borderRadius: '3px', backgroundColor: cellBg({ side, level }), border: `1px solid ${dsColorNew.grayBorder}` }}/>

/** The three classes, the Δ reading, the "!" and the unit line (criteria 12 and 24). */
export default function ChangeLegend({ unit, lor, dates = 0 }) {
	const item = { display: 'inline-flex', alignItems: 'center', gap: 0.75 }
	return <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, mt: 1.5, fontSize: 12, color: dsColorNew.textMuted }}>
		<Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
			<Box component="span" sx={item}>▼ − price went down {[3, 2, 1].map(l => swatch('cheaper', l))}{[1, 2, 3].map(l => swatch('dearer', l))} ▲ + price went up</Box>
			<Box component="span">≈ within ±2 %: no net change</Box>
			<Box component="span">Δ = engine change − market change, in points · negative: the engine went down more (or up less) than the market</Box>
			<Box component="span"><Box component="b" sx={{ color: dsColorNew.noteAmber }}>!</Box> fewer than 3 passes behind the cell</Box>
		</Box>
		<Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
			<Box component="span">{unitLine(unit, lor)}</Box>
			<Box sx={{ flex: 1 }}/>
			<Box component="span">Click a cell: its detail · click a date header: every ACRISS of that pick-up, below{dates > 8 ? ' · scroll sideways for more dates' : ''}</Box>
		</Box>
	</Box>
}
